import * as React from "react";

const CENHomeCardCheck: React.FC = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.25 5C13.25 5.19191 13.1768 5.38391 13.0303 5.53016L7.03027 11.5302C6.88438 11.6773 6.69219 11.75 6.5 11.75C6.30781 11.75 6.11609 11.6768 5.96984 11.5303L2.96984 8.53027C2.82336 8.38438 2.75 8.19219 2.75 8C2.75 7.57156 3.10039 7.25 3.5 7.25C3.69191 7.25 3.88391 7.32324 4.03016 7.46973L6.5 9.94062L11.9703 4.47031C12.1156 4.32336 12.3078 4.25 12.5 4.25C12.9008 4.25 13.25 4.57109 13.25 5Z"
                fill="#266B40"
            />
        </svg>
    );
};

export default React.memo(CENHomeCardCheck);
